import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SFFormBuilder } from "@sf-core";

import getSchema from "./schema.js";
import getUischema from "./uischema.js";

const EditUserTenantForm = ({ onChange, data }) => {
  const [schema, setSchema] = useState(null);
  const [uischema, setUischema] = useState(null);

  useEffect(async () => {
    const newSchema = await getSchema(data);
    setSchema(newSchema);
    setUischema(getUischema(newSchema));
  }, []);

  if (!schema || !uischema) return null;

  return (
    <SFFormBuilder
      schema={schema}
      uischema={uischema}
      data={data}
      onChange={onChange}
    />
  );
};

EditUserTenantForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default EditUserTenantForm;
